/* Presentation adapter for Shopify Forms 1210394. Submission stays with Forms. */
(() => {
  'use strict';
  const source = document.currentScript?.dataset.posterSrc;
  if (!source || window.npOtterWelcomeInstalled) return;
  window.npOtterWelcomeInstalled = true;
  const style = `
    section.np-otter-popup[data-sizing="form-wrapper"] {
      display: grid !important;
      grid-template-columns: minmax(0, .95fr) minmax(0, 1fr) !important;
      grid-template-areas: "art content" !important;
      width: min(760px, calc(100vw - 48px)) !important;
      min-width: 0 !important;
      max-width: 760px !important;
      max-height: calc(100dvh - 36px) !important;
      border-radius: 20px !important;
      overflow: auto !important;
    }
    .np-otter-popup > .np-otter-native-image { display: none !important; }
    .np-otter-popup > .np-otter-art {
      grid-area: art;
      margin: 0;
      min-width: 0;
      min-height: 460px;
      background: #fff8ec;
      overflow: hidden;
    }
    .np-otter-art img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
    .np-otter-popup > .np-otter-content {
      grid-area: content;
      align-self: center;
      min-width: 0;
      padding: 48px 32px 38px !important;
    }
    .np-otter-content h2 { line-height: 1.33 !important; }
    .np-otter-content button[type="submit"] { font-weight: 700 !important; }
    /* 44px tap target for the 12px close icon (Callie audit A09). */
    [class*="formCloseButton"] {
      display: inline-flex !important;
      align-items: center;
      justify-content: center;
      min-width: 44px;
      min-height: 44px;
      margin: -16px;
      cursor: pointer;
    }
    @media (max-width: 768px) {
      section.np-otter-popup[data-sizing="form-wrapper"] {
        width: min(420px, calc(100vw - 40px)) !important;
        grid-template-columns: minmax(0, 1fr) !important;
        grid-template-areas: "art" "content" !important;
        max-height: calc(100dvh - 24px) !important;
        border-radius: 16px !important;
      }
      .np-otter-popup > .np-otter-art { height: 168px; min-height: 0; }
      .np-otter-art img { object-fit: contain; }
      .np-otter-popup > .np-otter-content { padding: 22px 24px 24px !important; }
      .np-otter-content h2 { line-height: 1.4 !important; }
    }
    @media (max-width: 360px), (max-height: 660px) {
      .np-otter-popup > .np-otter-art { height: 128px; min-height: 0; }
      .np-otter-popup > .np-otter-content { padding: 18px 20px 20px !important; }
    }
  `;
  const roots = new WeakSet();
  let pending = false;
  function decorate() {
    pending = false;
    const host = document.getElementById('app-embed-container-1210394');
    const root = host?.shadowRoot;
    if (!root) return;
    if (!roots.has(root)) {
      roots.add(root);
      const sheet = document.createElement('style');
      sheet.dataset.npOtterStyle = '';
      sheet.textContent = style;
      root.appendChild(sheet);
      new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    }
    for (const dialog of root.querySelectorAll('section[data-sizing="form-wrapper"][role="dialog"]')) {
      const content = [...dialog.children].find(child => child.querySelector('h2'));
      if (!content) continue;
      dialog.classList.add('np-otter-popup');
      content.classList.add('np-otter-content');
      if (dialog.querySelector(':scope > .np-otter-art')) continue;
      const originalImage = dialog.firstElementChild;
      if (originalImage && originalImage !== content) originalImage.classList.add('np-otter-native-image');
      const art = document.createElement('figure');
      art.className = 'np-otter-art';
      const poster = document.createElement('img');
      poster.src = source;
      poster.alt = 'The Nuzzle Parcel otter with a little gift for you';
      poster.width = 1024;
      poster.height = 1536;
      poster.decoding = 'async';
      art.appendChild(poster);
      dialog.insertBefore(art, content);
    }
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(decorate);
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  schedule();
})();
